
export function parseColorValue(value: string) {

    let parsedColorString = "";
    const reg=/^#[0-9A-F]{6}$/i
    let isHexValue = reg.test(value)

    if (isHexValue) {
        // Color is hex value
        parsedColorString = value;

    } else {
        // Color is RGB or RGBA
        let rgbaList = value.split(',');
        parsedColorString = `rgb${rgbaList.length === 4 ? "a" : ""}(${rgbaList.join(',')})`
    }

    return parsedColorString
}